import { api, unwrap } from './client';

export function listAudit({ q = '', page = 0, size = 20 } = {}) {
  return unwrap(api.get('/api/audit-logs', { params: { q, page, size } }));
}
